import { Button, Link, Card, Flex, Heading, Icon, Text } from '@chakra-ui/react';
import NextLink from 'next/link';

import ArrowIcon from '@/assets/icons/ic-arrow-tilted.svg';
import VIDEO_MATCHES from '@/assets/images/landing/video-matches.png';

import { RedWideCard } from '@/components/ui/shared/cards/RedWideCard/RedWideCard';
import { ChakraNextResponsiveImage } from '@/components/ui/shared/image/ChakraNextResponsiveImage';

export const ShareYourScience = () => {
  return (
    <Flex flexDirection="column">
      <RedWideCard
        mx="auto"
        heading="This is a new opportunity for researchers to bring past conference work back to life and increase its long-term visibility. Whether from AAAI, ACL, or any other major venue — your presentations deserve to be seen, cited, and shared."
        smallHeading="Why now?"
      />
      <Flex
        flexDirection={{ base: 'column', md: 'row' }}
        alignItems="center"
        justifyContent="center"
        gap={{ base: 14, md: 24 }}
        mt={18}
      >
        <Flex flex={1} flexDirection="column">
          <Heading fontSize="4xl" as="h2" size="md">
            Extend the Impact of Your Research
          </Heading>
          <Text fontSize="xl" mt={6}>
            Are you looking for new opportunities to share your research with a global academic audience — and connect
            with peers who share your interests?
            <br />
            <br />
            Underline Science invites you to submit your conference presentations for inclusion in our Digital Video
            Library, now accessible to individual researchers for the first time.
            <br />
            <br />
            With over 55,000 talks from top conferences (AAAI, ACL, list of conferences and more), the Underline
            platform is used by university libraries, research institutions, and scholars worldwide.
            <br />
            <br />
            When you present at a conference, you typically retain the rights to your presentation. Now, you can give it
            a second life — not on public video platforms, but in a curated scholarly environment built for academic
            discovery, visibility, and collaboration.
          </Text>
        </Flex>
        <ChakraNextResponsiveImage w="354px" h="327px" src={VIDEO_MATCHES} alt="video matches" />
      </Flex>
      <Card borderRadius={16} maxW="690px" mx="auto" w="full" mt={12} p={6}>
        <Flex textAlign="center" gap={4} alignItems="center" flexDirection="column">
          <Heading as="h3" size="md">
            Submit Today
          </Heading>
          <Text fontSize="xl">
            Join thousands of researchers already using Underline to grow their academic impact.
          </Text>
          <NextLink href="/submit">
            <Button rightIcon={<Icon as={ArrowIcon} color="white" h={5} w={5} />} size="lg">
              Submit Your Presentation Now
            </Button>
          </NextLink>
          <Text>
            For questions, contact
            <Link ml={1} textColor="blue.500" href={`mailto:support@underline.io`}>
              support@underline.io
            </Link>
          </Text>
        </Flex>
      </Card>
    </Flex>
  );
};
